import { render, staticRenderFns } from "./weighing-details.vue?vue&type=template&id=4459d604&"
import script from "./weighing-details.vue?vue&type=script&lang=js&"
export * from "./weighing-details.vue?vue&type=script&lang=js&"
import style0 from "./weighing-details.vue?vue&type=style&index=0&id=4459d604&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports